import { AuthenticationService } from '@philips-internal/oswald-ui-core/lib/services';
import { JWTTokenClaims } from '../app/types';
import TokenConstants from '../constants/TokenConstants';

export class JWTTokenUtils {

  /**
   * Returns the value of the specified claim.
   * @param claimName TokenConstants
   * @returns
   */
  static getClaimValue(claimName: TokenConstants): string | null {
    const tokenClaims = AuthenticationService.getJWTToken()?.claims as unknown as JWTTokenClaims
    if(tokenClaims) {
      return tokenClaims[claimName];
    }

    return null;
  }
}